import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-card d-flex align-center justify-center"},[_c('img',{staticClass:"back-card wi-100",attrs:{"src":"/img/design/back-card.jpg","alt":"Card's back"}}),_c(VSkeletonLoader,{staticClass:"he-100",attrs:{"type":"image"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }